import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    Button,
    Checkbox,
    Divider,
    Flex,
    Image,
    Input,
    Select,
    Spinner,
    Text,
    Textarea,
    useMediaQuery
} from '@chakra-ui/react'
import {useHistory} from "react-router-dom";
import shortid from 'shortid';
import {getBase64} from "../utils";
import Popup from "./Popup";
import ENV from "../ENV.json";
import axios from "axios";
import DimensioneMap from "./DimensioneMap";
import MapLegend from "./MapLegend"
import Loading from "./Loading";
import './PointOfInterest.css';
import AgreeAndContinue from "./AgreeAndContinue";
import DocsElement from "./DocsElement";
import docs from "../utils/docs.json";
import LeaveEmpty from "./LeaveEmpty";
import RequestingPopup from "./RequestingPopup";
import CensimentoDim from "./CensimentoDim";
import {reactLocalStorage} from 'reactjs-localstorage';

axios.defaults.withCredentials = true;


let leave_key = undefined;

const PointOfInterestForm = (props) => {

    const userData = reactLocalStorage.getObject('User');
    //console.log("Ciao utente con id => " + userData?.ID);

    const history = useHistory();

    //Mediaquery
    const [isLargerThan1280] = useMediaQuery('(min-width: 1280px)')

    const [_, setIncompletePOI] = useState(false);

    //Questa variabile temporanea si ha a disposizione quando il POI è un POI salvato e non updato in piattaforma
    //Mongo identifier.
    const [_id, set_id] = useState(null); //ID temporaneo se è stato salvato l'incompleto
    const [ID, setID] = useState(null);

    const [title, setTitle] = useState("");

    const [address, setAddress] = useState("");

    const [LAT, setLAT] = useState("41.58864634379488");

    const [LONG, setLONG] = useState("14.672005176544191");

    const [description, setDescription] = useState("");

    const [storyIntroduction, setStoryIntroduction] = useState("");

    const [architectonic, setArchitectonic] = useState("");

    const [curiosity, setCuriosity] = useState("");

    const [bibliography, setBibliography] = useState("");

    //ACCESSIBILITY INFORMATION STATE
    //PARAPLEGICI
    const [isAccessibleForParaplegic, setIsAccessibleForParaplegic] = useState(false);
    const [paraplegicNote, setParaplegicNote] = useState("");

    //SORDI
    const [isAccessibleForDeaf, setIsAccessibleForDeaf] = useState(false);
    const [deafNote, setDeafNote] = useState("");

    //CIECHI
    const [isAccessibleForBlind, setIsAccessibleForBlind] = useState(true);
    const [blindNote, setBlindNote] = useState("-");

    //ACCESSIBILITA IN POSTO
    const [isAccessibilityInPlace, setIsAccessibilityInPlace] = useState(false);
    const [accessibilityNote, setAccessibilityNote] = useState("");

    //MACCHINA
    const [isAccessibleForCar, setIsAccessibleForCar] = useState(false);
    const [carNote, setCarNote] = useState("");

    //BICICLETTA
    const [isAccessibleForBike, setIsAccessibleForBike] = useState(false);
    const [bikeNote, setBikeNote] = useState("");

    //PIEDI
    const [isAccessibleForFoot, setIsAccessibleForFoot] = useState(false);
    const [footNote, setFootNote] = useState("");

    //AUTOBUS
    const [isAccessibleForBus, setIsAccessibleForBus] = useState(false);
    const [busNote, setBusNote] = useState("");


    //SKATEBOARD
    const [isAccessibleForSkate, setIsAccessibleForSkate] = useState(false);
    const [skateNote, setSkateNote] = useState("");

    //MOTORCYCLE
    const [isAccessibleForMotorcycle, setIsAccessibleForMotorcycle] = useState(false);
    const [motorcycleNote, setMotorcycleNote] = useState("");

    //HOURSE
    const [isAccessibleForHourse, setIsAccessibleForHourse] = useState(false);
    const [hourseNote, setHourseNote] = useState("");


    //URLS / IMAGES / TELEPHONE / EMAIL
    //URLS
    const [url, setUrl] = useState("");
    const [urlDescription, setUrlDescription] = useState("");
    const [insertUrls, setInsertUrls] = useState([]);

    //IMAGES
    const [image, setImage] = useState(null);
    const [insertFiles, setInsertFiles] = useState([]);
    const [imageDescription, setImageDescription] = useState("");

    //TELEPHONE
    const [telephone, setTelephone] = useState("");
    const [telephoneDescription, setTelephoneDescription] = useState("");
    const [insertTelephones, setInsertTelephones] = useState([]);

    //EMAILS
    const [email, setEmail] = useState("");
    const [emailDescription, setEmailDescription] = useState("");
    const [insertEmails, setInsertEmails] = useState([]);

    //Recuperare la lista delle categorie
    const [category, setCategory] = useState([]); //Tutte le categorie con sub type dal DB
    const [cat, setCat] = useState([]); //Solo i nomi delle categorie per semplicità
    const isCatSelected = useMemo(() => category.filter(e => e?.active)?.length !== 0, [category]);


    const [catDownloading, setCatDownloading] = useState(true);
    const [comuniDownloading, setComuniDownloading] = useState(true);
    const [comuni, setComuni] = useState([]);
    const [selectedComune, setSelectedComune] = useState("70001");

    //


    const [isAgree, setIsAgree] = useState(true);
    useEffect(() => {
        setCatDownloading(true);
        setComuniDownloading(true);

        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/obtain/category`, {withCredentials: true, credentials: 'include'})
            .then(function (response) {
                if (response?.data?.status) {
                    setCategory(response?.data?.rows.map(e => {
                        //Cerca la categoria interessata
                        if (props?.data) {
                            const crrID = e?.ID;
                            const result = props?.data?.categories.filter(e => e?.ID_CATEGORY === crrID);
                            return (
                                {...e, active: result[0]?.ID_CATEGORY ? true : false}
                            )
                        } else {
                            return (
                                {...e, active: false}
                            )
                        }
                    }))
                    setCat(response?.data?.category);
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare le categorie. Ricarica la pagina"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    //history.push('/')
                    logout();
                }
            })
            .then(function (response) {
                setCatDownloading(false);
            });

        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/comuni`)
            .then(function (response) {
                if (response?.data?.status) {
                    setComuni(response?.data?.rows)
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i comuni. Ricarica la pagina!"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    //history.push('/')
                    logout();
                }
            })
            .then(function (response) {
                setComuniDownloading(false);
            });

    }, []);

    const logout = useCallback(() => history.push('/'), [history])


    const [isCompleted, setIsCompleted] = useState(true)
    const [missingNote, setMissingNote] = useState("");

    //Synch props with state
    //Controllare il comune
    useEffect(() => {
        if (!props?.data) return;
        console.log(`Valore dei cavalli: ${props?.data?.hourseNote}`)
        //Va controllato attentamente il valore che si assegna ad ogni campo
        if (props?.data?.ID !== undefined) setID(props?.data?.ID);
        if (props?.data?.PRO_COM !== undefined) setSelectedComune(`${props?.data?.PRO_COM}`);
        if (props?.data?._id !== undefined) set_id(props?.data?._id);
        if (props?.data?.title !== undefined) setTitle(props?.data?.title)
        if (props?.data?.address !== undefined) setAddress(props?.data?.address)
        if (props?.data?.lat !== undefined) setLAT(props?.data?.lat)
        if (props?.data?.longitude !== undefined) setLONG(props?.data?.longitude)
        if (props?.data?.description !== undefined) setDescription(props?.data?.description)
        if (props?.data?.storyIntroduction !== undefined) setStoryIntroduction(props?.data?.storyIntroduction)
        if (props?.data?.architectonic !== undefined) setArchitectonic(props?.data?.architectonic)
        if (props?.data?.curiosity !== undefined) setCuriosity(props?.data?.curiosity)
        if (props?.data?.bibliography !== undefined) setBibliography(props?.data?.bibliography)
        if (props?.data?.isAccessibleForParaplegic !== undefined) setIsAccessibleForParaplegic(props?.data?.isAccessibleForParaplegic)
        if (props?.data?.paraplegicNote !== undefined) setParaplegicNote(props?.data?.paraplegicNote)
        if (props?.data?.isAccessibleForDeaf !== undefined) setIsAccessibleForDeaf(props?.data?.isAccessibleForDeaf)
        if (props?.data?.deafNote !== undefined) setDeafNote(props?.data?.deafNote)
        if (props?.data?.isAccessibleForBlind !== undefined) setIsAccessibleForBlind(props?.data?.isAccessibleForBlind)
        if (props?.data?.blindNote !== undefined) setBlindNote(props?.data?.blindNote)
        if (props?.data?.isAccessibilityInPlace !== undefined) setIsAccessibilityInPlace(props?.data?.isAccessibilityInPlace)
        if (props?.data?.accessibilityNote !== undefined) setAccessibilityNote(props?.data?.accessibilityNote)
        if (props?.data?.isAccessibleForCar !== undefined) setIsAccessibleForCar(props?.data?.isAccessibleForCar)
        if (props?.data?.carNote !== undefined) setCarNote(props?.data?.carNote)
        if (props?.data?.isAccessibleForBike !== undefined) setIsAccessibleForBike(props?.data?.isAccessibleForBike)
        if (props?.data?.bikeNote !== undefined) setBikeNote(props?.data?.bikeNote)
        if (props?.data?.isAccessibleForFoot !== undefined) setIsAccessibleForFoot(props?.data?.isAccessibleForFoot)
        if (props?.data?.footNote !== undefined) setFootNote(props?.data?.footNote)
        if (props?.data?.isAccessibleForBus !== undefined) setIsAccessibleForBus(props?.data?.isAccessibleForBus)
        if (props?.data?.busNote !== undefined) setBusNote(props?.data?.busNote)
        if (props?.data?.isAccessibleForSkate !== undefined) setIsAccessibleForSkate(props?.data?.isAccessibleForSkate)
        if (props?.data?.skateNote !== undefined) setSkateNote(props?.data?.skateNote)
        if (props?.data?.isAccessibleForMotorcycle !== undefined) setIsAccessibleForMotorcycle(props?.data?.isAccessibleForMotorcycle)
        if (props?.data?.motorcycleNote !== undefined) setMotorcycleNote(props?.data?.motorcycleNote)
        if (props?.data?.isAccessibleForHourse !== undefined) setIsAccessibleForHourse(props?.data?.isAccessibleForHourse)
        if (props?.data?.hourseNote !== undefined) setHourseNote(props?.data?.hourseNote)
        if (props?.data?.urls !== undefined) setInsertUrls(props?.data?.urls)
        if (props?.data?.images !== undefined) setInsertFiles(props?.data?.images)
        if (props?.data?.telephones !== undefined) setInsertTelephones(props?.data?.telephones)
        if (props?.data?.emails !== undefined) setInsertEmails(props?.data?.emails)
        if (props?.data?.isCompleted !== undefined) setIsCompleted(props?.data?.isCompleted)
        if (props?.data?.missingNote !== undefined) setMissingNote(props?.data?.missingNote)
        if (props?.data?.isIncompletePoi !== undefined) setIncompletePOI(props?.data?.isIncompletePoi);
    }, [props]);

    //Verifica che tutti i campi siano stati compilati correttamente
    const isAddEnabled = useMemo(() => {

            //firstWave
            const firstWave = title !== "" && address !== "" && LAT !== ""
                && LONG !== "" && description !== "" && storyIntroduction?.length !== 0
                && architectonic?.length !== 0 && curiosity?.length !== 0 && bibliography?.length !== 0 && selectedComune !== "";

            /*console.log(`title: ${title}`);
            console.log(`address: ${address}`)
            console.log(`LAT: ${LAT}`);
            console.log(`LONG: ${LONG}`);
            console.log(`storyIntroduction: ${storyIntroduction}`);
            console.log(`architectonic: ${architectonic}`);
            console.log(`curiosity: ${curiosity}`);
            console.log(`bibliography: ${bibliography}`);
            console.log(`selectedComune: ${selectedComune}`);*/
            //secondWave

            const paraplegic = paraplegicNote?.length > 0
            const deaf = deafNote?.length > 0

            const blind = blindNote?.length > 0
            const accessibility = accessibilityNote?.length > 0
            const car = carNote?.length > 0
            const bike = bikeNote?.length > 0
            const foot = footNote?.length > 0
            const bus = busNote?.length > 0
            const skate = skateNote?.length > 0
            const motorcycle = motorcycleNote?.length > 0
            const hourse = hourseNote?.length > 0

            const secondWave = paraplegic && deaf && blind && accessibility && car && bike && foot && bus && skate && motorcycle && hourse;

            /*console.log(`paraplegic: ${paraplegic}`);
            console.log(`deaf: ${deaf}`)
            console.log(`blind: ${blind}`);
            console.log(`accessibility: ${accessibility}`);
            console.log(`car: ${car}`);
            console.log(`bike: ${bike}`);
            console.log(`foot: ${foot}`);
            console.log(`bus: ${bus}`);
            console.log(`skate: ${skate}`);
            console.log(`motorcycle: ${motorcycle}`);
            console.log(`hourse: ${hourse}`);*/

            //thirdWave
            let urls = true;
            insertUrls?.forEach(element => {
                const completedUrl_i = element?.link?.length > 0 && element?.description?.length > 0
                urls = urls && completedUrl_i;
            })

            let e_mail = true;
            insertEmails?.forEach(element => {
                const completedUrl_i = element?.email?.length > 0 && element?.description?.length > 0
                e_mail = e_mail && completedUrl_i;
            })

            let tel = true;
            insertTelephones?.forEach(element => {
                const completedUrl_i = element?.telephone?.length > 0 && element?.description?.length > 0
                tel = tel && completedUrl_i;
            })

            let img = true;
            insertFiles?.forEach(element => {
                const completedUrl_i = element?.description?.length > 0 && element?.imageBase64?.length > 0
                img = img && completedUrl_i;
            })

            if (insertFiles?.length === 0) {
                img = false;
            }

            const thirdwave = urls && e_mail && tel && img;

            /*console.log(`urls: ${urls}`);
            console.log(`e_mail: ${e_mail}`);
            console.log(`tel: ${tel}`);
            console.log(`img: ${img}`);*/
            //console.log("firstWave: " + firstWave + " secondWave: " + secondWave + " thirdwave: " + thirdwave + "isAgree: " + isAgree);

            return (firstWave && secondWave && thirdwave && isAgree);

        },
        [
            title, address, LAT, LONG, description, paraplegicNote, deafNote, blindNote
            , accessibilityNote, carNote, bikeNote, footNote, busNote,
            skateNote, motorcycleNote, hourseNote,
            insertUrls, insertEmails, insertTelephones, insertFiles, storyIntroduction, architectonic, curiosity,
            bibliography, isAgree, selectedComune
        ]);

    //POPUPS
    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});


    const [isAddPoiLoading, setIsAddPoiLoading] = useState(false);
    //CALLBACK FOR SAVE POI
    const addPoi = useCallback(() => {
            setIsAddPoiLoading(true)
            let data = {
                title: title,
                PRO_COM: selectedComune,
                address: address,
                LAT: LAT.toString(),
                LONG: LONG.toString(),
                isCompleted: isCompleted,
                missingNote: missingNote,
                description: description,
                storyIntroduction: storyIntroduction,
                architectonic: architectonic,
                curiosity: curiosity,
                bibliography: bibliography,
                categories: category.filter(e => e?.active).map(e => ({ID_CATEGORY: e?.ID})),
                isAccessibleForParaplegic: isAccessibleForParaplegic,
                paraplegicNote: paraplegicNote,
                isAccessibleForDeaf: isAccessibleForDeaf,
                deafNote: deafNote,
                isAccessibleForBlind: isAccessibleForBlind,
                blindNote: blindNote,
                isAccessibilityInPlace: isAccessibilityInPlace,
                accessibilityNote: accessibilityNote,
                isAccessibleForCar: isAccessibleForCar,
                carNote: carNote,
                isAccessibleForBike: isAccessibleForBike,
                bikeNote: bikeNote,
                isAccessibleForFoot: isAccessibleForFoot,
                footNote: footNote,
                isAccessibleForBus: isAccessibleForBus,
                busNote: busNote,
                isAccessibleForSkate: isAccessibleForSkate,
                skateNote: skateNote,
                isAccessibleForMotorcycle: isAccessibleForMotorcycle,
                motorcycleNote: motorcycleNote,
                isAccessibleForHourse: isAccessibleForHourse,
                hourseNote: hourseNote,
                urls: insertUrls.map(elem => ({
                    link: elem?.link,
                    description: elem?.description
                })),
                emails: insertEmails.map(elem => ({
                    email: elem?.email,
                    description: elem?.description
                })),
                telephones: insertTelephones.map(elem => ({
                    telephone: elem?.telephone,
                    description: elem?.description
                })),
                images: insertFiles.map(elem => ({
                    imageBase64: elem?.imageBase64,
                    description: elem?.description,
                    MB: elem?.MB
                }))
            }

            //CHIAMATA API PER salvare il POI.
            //Check right post (add or update)?

            //Se esiste un mongo id allora conviene inserirlo in modo che venga eliminato
            if (_id) {
                //console.log("Sembra che l'_id sia presente quindi lo aggiungo alla lista")
                //Verrà eliminato dal BE
                data = {_id, ...data}
            }

            axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/add/poi`, data)
                .then(function (response) {
                    if (response?.data?.status) {
                        setPopupData(response?.data)
                        setModalOpen(true);
                        if (props?.onRefresh) {
                            props?.onRefresh();
                            //window.location.reload();
                        }
                    } else {
                        setPopupData(response?.data)
                        setModalOpen(true);
                    }
                })
                .catch(function (error) {
                    setPopupData({
                        status: false,
                        title: "Errore imprevisto",
                        message: "Non è stato possibile caricare le categorie. Ricarica la pagina"
                    })
                    setModalOpen(true);
                    if (error.response.status === 403) {
                        history.push('/')
                    }
                })
                .then(function (response) {
                    //RESET LOADING OF POI SAVE
                    setIsAddPoiLoading(false);
                });
        },
        [
            _id, title, category, address, LAT, LONG, description, isAccessibleForParaplegic, paraplegicNote, isAccessibleForDeaf, deafNote, isAccessibleForBlind, blindNote,
            isAccessibilityInPlace, accessibilityNote, isAccessibleForCar, carNote, isAccessibleForBike, bikeNote, isAccessibleForFoot, footNote,
            isAccessibleForBus, busNote, isAccessibleForSkate, skateNote, isAccessibleForMotorcycle, motorcycleNote, isAccessibleForHourse, hourseNote,
            insertUrls, insertEmails, insertTelephones, insertFiles, storyIntroduction, architectonic, curiosity, bibliography, isCompleted, missingNote, history
        ]);

    //Questa route serve per salvare un punto di interesse in maniera temporanea nel DB
    const [isSavePoiDownloading, setIsSavePoiDownloading] = useState(false);
    const savePoi = useCallback(() => {
            //Preparazione dell'oggetto da inviare
            setIsSavePoiDownloading(true)
            console.log("Sto per salvare il PRO_COM")
            let data = {
                title: title || "",
                PRO_COM: `${selectedComune}`,
                address: address || "",
                LAT: LAT.toString() || "",
                LONG: LONG.toString() || "",
                isCompleted: isCompleted,
                missingNote: missingNote || "",
                description: description || "",
                storyIntroduction: storyIntroduction || "",
                architectonic: architectonic || "",
                curiosity: curiosity || "",
                bibliography: bibliography || "",
                categories: category.filter(e => e?.active).map(e => ({ID_CATEGORY: e?.ID})),
                isAccessibleForParaplegic: isAccessibleForParaplegic,
                paraplegicNote: paraplegicNote || "",
                isAccessibleForDeaf: isAccessibleForDeaf,
                deafNote: deafNote || "",
                isAccessibleForBlind: isAccessibleForBlind,
                blindNote: blindNote || "",
                isAccessibilityInPlace: isAccessibilityInPlace,
                accessibilityNote: accessibilityNote || "",
                isAccessibleForCar: isAccessibleForCar,
                carNote: carNote || "",
                isAccessibleForBike: isAccessibleForBike,
                bikeNote: bikeNote || "",
                isAccessibleForFoot: isAccessibleForFoot,
                footNote: footNote || "",
                isAccessibleForBus: isAccessibleForBus,
                busNote: busNote || "",
                isAccessibleForSkate: isAccessibleForSkate,
                skateNote: skateNote || "",
                isAccessibleForMotorcycle: isAccessibleForMotorcycle,
                motorcycleNote: motorcycleNote || "",
                isAccessibleForHourse: isAccessibleForHourse,
                hourseNote: hourseNote || "",
                urls: insertUrls.map(elem => ({
                    link: elem?.link,
                    description: elem?.description
                })) || [],
                emails: insertEmails.map(elem => ({
                    email: elem?.email,
                    description: elem?.description
                })) || [],
                telephones: insertTelephones.map(elem => ({
                    telephone: elem?.telephone,
                    description: elem?.description
                })) || [],
                images: insertFiles.map(elem => ({
                    imageBase64: elem?.imageBase64,
                    description: elem?.description,
                    MB: elem?.MB
                })) || [],
            }

            //Se l'_id di Mongo c'è passarlo perché save funge sia da insert che da update.
            if (_id) {
                data = {...data, _id}
            }

            //Salvare direttamente (la route penserà a risolvere la presenza o meno del punto di interesse create/update)
            axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/save/poi/temp`, data)
                .then(function (response) {
                    if (response?.data?.status) {
                        setPopupData(response?.data)
                        setModalOpen(true);

                        //Aggiornare sempre l'_id dopo un salvataggio a prescindere
                        if (response?.data?.result?.insertedId) {
                            set_id(response?.data?.result?.insertedId);
                        }
                    } else {
                        setPopupData(response?.data)
                        setModalOpen(true);
                    }
                })
                .catch(function (error) {
                    setPopupData({
                        status: false,
                        title: "Errore imprevisto",
                        message: "Non è stato possibile salvare il punto di interesse!"
                    })
                    setModalOpen(true);
                    if (error.response.status === 403) {
                        history.push('/')
                    }
                })
                .then(function (response) {
                    setIsSavePoiDownloading(false)
                });

        },
        [LAT, LONG, accessibilityNote, address, architectonic, bibliography, bikeNote, blindNote, busNote, carNote,
            category, curiosity, deafNote, description, footNote, hourseNote, insertEmails, insertFiles, insertTelephones, insertUrls,
            isAccessibilityInPlace, isAccessibleForBike, isAccessibleForBlind, isAccessibleForBus, isAccessibleForCar, isAccessibleForDeaf,
            isAccessibleForFoot, isAccessibleForHourse, isAccessibleForMotorcycle, isAccessibleForParaplegic, isAccessibleForSkate,
            isCompleted, missingNote, motorcycleNote, paraplegicNote, skateNote, storyIntroduction, title, _id, history, selectedComune]);

    const [isUpdatePoiDownloading, setIsUpdatePoiDownloading] = useState(false);

    const updatePoi = useCallback(() => {

            let isCompletedFix = null;

            if (typeof isCompleted === 'string') {
                isCompletedFix = isCompleted === '0' ? true : false;
            }

            let data = {
                ID: ID,
                title: title || "",
                PRO_COM: selectedComune,
                address: address || "",
                LAT: LAT.toString() || "",
                LONG: LONG.toString() || "",
                isCompleted: (typeof isCompleted === 'string') ? isCompletedFix : isCompleted,
                missingNote: missingNote || "",
                description: description || "",
                storyIntroduction: storyIntroduction || "",
                architectonic: architectonic || "",
                curiosity: curiosity || "",
                bibliography: bibliography || "",
                categories: category.filter(e => e?.active).map(e => ({ID_CATEGORY: e?.ID})),
                isAccessibleForParaplegic: isAccessibleForParaplegic,
                paraplegicNote: paraplegicNote || "",
                isAccessibleForDeaf: isAccessibleForDeaf,
                deafNote: deafNote || "",
                isAccessibleForBlind: isAccessibleForBlind,
                blindNote: blindNote || "",
                isAccessibilityInPlace: isAccessibilityInPlace,
                accessibilityNote: accessibilityNote || "",
                isAccessibleForCar: isAccessibleForCar,
                carNote: carNote || "",
                isAccessibleForBike: isAccessibleForBike,
                bikeNote: bikeNote || "",
                isAccessibleForFoot: isAccessibleForFoot,
                footNote: footNote || "",
                isAccessibleForBus: isAccessibleForBus,
                busNote: busNote || "",
                isAccessibleForSkate: isAccessibleForSkate,
                skateNote: skateNote || "",
                isAccessibleForMotorcycle: isAccessibleForMotorcycle,
                motorcycleNote: motorcycleNote || "",
                isAccessibleForHourse: isAccessibleForHourse,
                hourseNote: hourseNote || "",
                urls: insertUrls.map(elem => ({
                    ID: elem?.ID,
                    link: elem?.link,
                    description: elem?.description
                })) || [],
                emails: insertEmails.map(elem => ({
                    ID: elem?.ID,
                    email: elem?.email,
                    description: elem?.description
                })) || [],
                telephones: insertTelephones.map(elem => ({
                    ID: elem?.ID,
                    telephone: elem?.telephone,
                    description: elem?.description
                })) || [],
                images: insertFiles.map(elem => ({
                    ID: elem?.ID,
                    imageBase64: elem?.imageBase64,
                    description: elem?.description,
                    MB: elem?.MB
                })) || []
            }

            setIsUpdatePoiDownloading(true);
            axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/update/poi`, data)
                .then(function (response) {
                    if (response?.data?.status) {
                        setPopupData(response?.data)
                        setModalOpen(true);
                    } else {
                        setPopupData(response?.data)
                        setModalOpen(true);
                    }
                })
                .catch(function (error) {
                    setPopupData({
                        status: false,
                        title: "Errore imprevisto",
                        message: "Non è stato possibile aggiornare il punto di interesse!"
                    })
                    setModalOpen(true);
                    if (error.response.status === 403) {
                        history.push('/')
                    }
                    setIsUpdatePoiDownloading(false);
                })
                .then(function (response) {
                    setIsUpdatePoiDownloading(false);
                });
        },
        [ID, LAT, LONG, accessibilityNote, address, architectonic, bibliography, bikeNote, blindNote, busNote, carNote,
            category, curiosity, deafNote, description, footNote, hourseNote, insertEmails, insertFiles, insertTelephones, insertUrls,
            isAccessibilityInPlace, isAccessibleForBike, isAccessibleForBlind, isAccessibleForBus, isAccessibleForCar, isAccessibleForDeaf,
            isAccessibleForFoot, isAccessibleForHourse, isAccessibleForMotorcycle, isAccessibleForParaplegic, isAccessibleForSkate,
            isCompleted, missingNote, motorcycleNote, paraplegicNote, skateNote, storyIntroduction, title, _id, history, selectedComune]
    )

    const onFileChange = event => {
        const file = event?.target?.files[0]
        //console.log(`Dimensione file ${file?.size}`)

        if (file?.type !== 'image/jpeg' && file?.type !== 'image/png') {
            setPopupData({
                status: false,
                title: 'File non caricato',
                message: `Il formato ${file?.type} non è consentito`
            })
            setModalOpen(true)
            return;
        }
        const MB = (Math.round(((file?.size / 1024) / 1024) * 100) / 100).toFixed(2);
        const MAX_SIZE = 2;
        const MAX_BUFFER_SIZE = 10;

        let CRR_BUFFER_SIZE = 0

        insertFiles.forEach(elem => CRR_BUFFER_SIZE += parseFloat(elem?.MB));

        //console.log(`Attuale banda usata ${CRR_BUFFER_SIZE}-${MAX_BUFFER_SIZE}MB`)

        if (MB > MAX_SIZE) {
            setPopupData({
                status: false,
                title: 'Dimensioni non consentite',
                message: `Non eccedere ${MAX_SIZE}MB (hai tentato di caricare ${MB}MB)`
            })
            setModalOpen(true)
            return;
        } else if (CRR_BUFFER_SIZE >= MAX_BUFFER_SIZE) {
            setPopupData({
                status: false,
                title: 'Dimensioni non consentite',
                message: `Hai ecceduto il limite massimo di MB di 100 (attuale: ${MAX_BUFFER_SIZE})`
            })
            setModalOpen(true)
            return;
        }
        //Generare il base64 dell'immagine
        getBase64(file)
            .then(result => {
                file["base64"] = result;
                const objectUrl = URL.createObjectURL(file)
                setImage({
                    preview: objectUrl,
                    imageBase64: result,
                    filename: file?.name,
                    type: file?.type,
                    MB: MB
                });
            })
            .catch(err => {
                //ERRORE NELLA GENERAZIONE
                setPopupData({
                    status: false,
                    title: 'File non caricato',
                    message: 'Non è possibile inserire questo contenuto'
                })
                setModalOpen(true)
            });
    };

    const [isDialogConfirmOpen, setIsDialogConfirmOpen] = useState(false);
    const leave = {
        "address": {func: () => setAddress('-')},
        "description": {func: () => setDescription('-')},
        "storyIntroduction": {func: () => setStoryIntroduction('-')},
        "architectonic_description": {func: () => setArchitectonic('-')},
        "curiosity": {func: () => setCuriosity('-')},
        "bibliography": {func: () => setBibliography('-')},
        "censimento": {func: () => setBibliography('Censimento di Dimensione Explorer')}
    };

    return (
        <Flex className={"poi_container"}>
            <Flex flexDirection="column" gap="10px">
                <div style={{display: "flex", alignItems: "center"}}>
                    <Text style={{marginRight: '10px'}}>Titolo</Text>
                    <DocsElement docs={docs.title.docs}/>
                </div>


                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 200 caratteri (${title?.length || "0"}/200)`}</Text>
                <Input
                    isInvalid={title?.length === 0}
                    value={title}
                    onChange={(event) => setTitle(event?.target?.value)}
                />
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Indirizzo</Text>
                    <DocsElement docs={docs.address.docs}/>
                    {/*Lasciare vuoto il campo*/}
                    <LeaveEmpty
                        onClick={() => {
                            if (address && address?.length > 0 && address !== '-') {
                                leave_key = "address";
                                setIsDialogConfirmOpen(true);
                            } else {
                                setAddress('-')
                            }
                        }}
                    />
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 500 caratteri (${address?.length || "0"}/500)`}</Text>
                <Input isInvalid={address?.length === 0} value={address}
                       onChange={(event) => setAddress(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <Text>Scegli il comune del luogo di interesse</Text>
                <DocsElement docs={docs.comune.docs}/>
                <Select
                    isRequired
                    value={selectedComune}
                    size='md'
                    onChange={(event) => {
                        setSelectedComune(event?.target?.value)
                    }}
                >
                    {
                        comuni.map(e => {
                            return (
                                <option key={e?.PRO_COM} value={e?.PRO_COM}>
                                    {e?.name}
                                </option>
                            );
                        })
                    }
                </Select>
            </Flex>
            <Flex flexDirection={`${!isLargerThan1280 ? 'column' : 'row'}`}
                  gap="10px"
                  padding="10px"
                  borderRadius="10px"
            >
                <Flex flexDirection="column" gap="10px" flex={1}>
                    <Flex flexDirection="column" gap="10px">
                        <DocsElement docs={docs.lat_long.docs}/>
                        <Text>Latitudine</Text>
                        <Input
                            //isDisabled
                            isInvalid={LAT?.length === 0}
                            value={LAT}
                            onChange={(event) => setLAT(event?.target?.value)}
                        />
                    </Flex>
                    <Flex flexDirection="column" gap="10px">
                        <Text>Longitudine</Text>
                        <Input
                            //isDisabled
                            isInvalid={LONG?.length === 0} value={LONG}
                            onChange={(event) => setLONG(event?.target?.value)}
                        />
                    </Flex>
                    <Text fontWeight={"bold"}>REGOLE</Text>
                    <Text>La mappa è dotata di un campo di ricerca</Text>
                    <Text>Un semplice click sulla mappa imposterà il segnalino blu nel punto esatto del click (tale
                        azione modificherà automaticamente LAT, LONG per te)</Text>
                    <Text>E' possibile inserire un solo segnalino blu</Text>
                    <Text fontWeight={"bold"}>Assicurarsi che il segnalino blu sia impostato sul luogo corretto.</Text>
                    <MapLegend isAdded isTemp isCurrent isEdit={false}/>
                </Flex>
                <Flex flexDirection="column" flex={2}>
                    <DimensioneMap
                        zoom={props?.data?.lat ? 16 : 9}
                        pos={{lat: LAT, lng: LONG}}
                        startPos={
                            (props?.startPos && props?.edit === true) ?
                                props?.startPos
                                :
                                {lat: "41.58864634379488", lng: "14.672005176544191"}
                        }
                        onEdit={(pos) => {
                            //Execute at first and at every change
                            if (pos) {
                                setLAT(pos?.lat || "");
                                setLONG(pos?.lng || "")
                            }
                        }}
                    />
                </Flex>

            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Descrizione del luogo</Text>
                    <DocsElement docs={docs.description.docs}/>
                    <LeaveEmpty
                        onClick={() => {
                            if (description && description?.length > 0 && description !== '-') {
                                leave_key = "description";
                                setIsDialogConfirmOpen(true);
                            } else {
                                setDescription('-')
                            }
                        }}/>
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 5000 caratteri (${description?.length || "0"}/5000)`}</Text>
                <Textarea isInvalid={description?.length === 0} value={description}
                          onChange={(event) => setDescription(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Introduzione storica</Text>
                    <DocsElement docs={docs.story_introduction.docs}/>
                    <LeaveEmpty onClick={() => {
                        if (storyIntroduction && storyIntroduction?.length > 0 && storyIntroduction !== '-') {
                            leave_key = "storyIntroduction";
                            setIsDialogConfirmOpen(true);
                        } else {
                            setStoryIntroduction('-')
                        }
                    }}/>
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${storyIntroduction?.length || "0"}/2000)`}</Text>

                <Textarea isInvalid={storyIntroduction?.length === 0} value={storyIntroduction}
                          onChange={(event) => setStoryIntroduction(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Descrizione architettonica</Text>
                    <DocsElement docs={docs.architectonic_description.docs}/>
                    <LeaveEmpty onClick={() => {
                        if (architectonic && architectonic?.length > 0 && architectonic !== '-') {
                            leave_key = "architectonic_description";
                            setIsDialogConfirmOpen(true);
                        } else {
                            setArchitectonic('-')
                        }
                    }}/>
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${architectonic?.length || "0"}/2000)`}</Text>
                <Textarea isInvalid={architectonic?.length === 0} value={architectonic}
                          onChange={(event) => setArchitectonic(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Curiosità</Text>
                    <DocsElement docs={docs.curiosity.docs}/>
                    <LeaveEmpty onClick={() => {
                        if (curiosity && curiosity?.length > 0 && curiosity !== '-') {
                            leave_key = "curiosity";
                            setIsDialogConfirmOpen(true);
                        } else {
                            setCuriosity('-')
                        }
                    }}/>
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${curiosity?.length || "0"}/2000)`}</Text>
                <Textarea isInvalid={curiosity?.length === 0} value={curiosity}
                          onChange={(event) => setCuriosity(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column" gap="10px">
                <div className={'intestation_field_command'}>
                    <Text style={{marginRight: '10px'}}>Bibliografia</Text>
                    <DocsElement docs={docs.bibliography.docs}/>
                    <LeaveEmpty onClick={() => {
                        if (bibliography && bibliography?.length > 0 && bibliography !== '-') {
                            leave_key = "bibliography";
                            setIsDialogConfirmOpen(true);
                        } else {
                            setBibliography('-')
                        }
                    }}/>
                    <CensimentoDim
                        disabled={userData?.ID !== 1}
                        onClick={() => {
                            if (bibliography && bibliography?.length > 0) {
                                leave_key = "censimento";
                                setIsDialogConfirmOpen(true);
                            } else {
                                setBibliography('Censimento di Dimensione Explorer');
                            }
                        }}
                    />
                </div>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${bibliography?.length || "0"}/2000)`}</Text>
                <Textarea isInvalid={bibliography?.length === 0} value={bibliography}
                          onChange={(event) => setBibliography(event?.target?.value)}/>
            </Flex>

            {/* GESTIONE DELLE CATEGORIE */}
            <Text textAlign="center">SCEGLI DELLE CATEGORIE A CUI IL POSTO FA RIFERIMENTO</Text>
            <DocsElement docs={docs.categories.docs}/>
            <Flex
                flexDirection="column"
                padding="10px"
                border={`${isCatSelected ? '1' : '2'}px solid ${isCatSelected ? 'black' : 'red'}`}
                borderRadius="10px"
            >
                {catDownloading && <Spinner color='red.500'/>}
                {
                    !catDownloading && (category?.length === 0 || cat?.length === 0) &&
                    <Text>ATTENZIONE NON E' STATO POSSIBILE CARICARE LE CATEGORIE</Text>
                }
                <Flex flexDirection={"row"} flexWrap={"wrap"}>
                    {
                        cat.map(element => {
                            return (
                                <Flex key={element} flexDirection="column" padding="20px">
                                    <h2 style={{fontWeight: 600}}>{`${element.toUpperCase()}`}</h2>
                                    {
                                        category.filter(e => e?.type === element).sort((a, b) => a?.sub_type > b?.sub_type ? 1 : -1).map(cat => {
                                            return (
                                                <Flex key={cat?.ID}>
                                                    <Checkbox
                                                        colorScheme="orange"
                                                        isChecked={cat?.active}
                                                        onChange={(event) => {
                                                            setCategory(prevState => {
                                                                return (
                                                                    prevState.map(e => {
                                                                        return e?.ID === cat?.ID ? {
                                                                            ...e,
                                                                            active: event?.target?.checked
                                                                        } : e
                                                                    }, [])
                                                                )
                                                            })
                                                        }}
                                                    >
                                                        {`${cat?.sub_type}`}</Checkbox>
                                                </Flex>
                                            )
                                        })
                                    }
                                </Flex>
                            )
                        })
                    }
                </Flex>
            </Flex>

            <Text textAlign="center">ACCESSIBILITA'</Text>
            <DocsElement docs={docs.accessibility.docs}/>
            <Flex flexDirection="column">
                <Checkbox
                    onChange={() => setIsAccessibleForParaplegic(!isAccessibleForParaplegic)}
                    isChecked={isAccessibleForParaplegic}
                >
                    Accessibile per persone con disabilità motoria? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile alle persone con disabilità motoria</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${paraplegicNote?.length || "0"}/2000)`}</Text>

                <Textarea isInvalid={paraplegicNote?.length === 0}
                          value={paraplegicNote}
                          onChange={(event) => setParaplegicNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    onChange={() => setIsAccessibleForDeaf(!isAccessibleForDeaf)}
                    isChecked={isAccessibleForDeaf}
                >
                    Accessibile per persone con disabilità sensoriale? (Attiva se pensi sia accessibile)
                </Checkbox>
                <Text>Descrivi perchè è/non è accessibile alle persone con disabilità sensoriale</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${deafNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={deafNote?.length === 0}
                    value={deafNote}
                    onChange={(event) => setDeafNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                {/*<Checkbox
                    onChange={() => setIsAccessibleForBlind(!isAccessibleForBlind)}
                    isChecked={isAccessibleForBlind}
                >
                    Accessibile per non vedenti? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile ai non vedenti</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${blindNote?.length || "0"}/2000)`}</Text>
                <Textarea isInvalid={blindNote?.length === 0}
                          value={blindNote}
                          onChange={(event) => setBlindNote(event?.target?.value)}/>
                          */}
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibilityInPlace}
                    onChange={() => setIsAccessibilityInPlace(!isAccessibilityInPlace)}
                >
                    Ci sono informazioni accessibili a persone con disabilità? (Es: braile, NFC, QR-Code) (Attiva se
                    pensi ci siano)
                </Checkbox>
                <Text>Descrivi se [ci sono/ non ci sono] informazioni di accessibilità sul posto.</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri ${accessibilityNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={accessibilityNote?.length === 0}
                    value={accessibilityNote}
                    onChange={(event) => setAccessibilityNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForCar}
                    onChange={() => setIsAccessibleForCar(!isAccessibleForCar)}
                >
                    Accessibile in auto? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile in auto (descrivere eventuali parcheggi o distributori di
                    benzina)</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${carNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={carNote?.length === 0}
                    value={carNote}
                    onChange={(event) => setCarNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForBike}
                    onChange={() => setIsAccessibleForBike(!isAccessibleForBike)}
                >
                    Accessibile in bicicletta? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile in biciletta (descrivi eventuali punti bici)</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${bikeNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={bikeNote?.length === 0}
                    value={bikeNote}
                    onChange={(event) => setBikeNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForFoot}
                    onChange={() => setIsAccessibleForFoot(!isAccessibleForFoot)}
                >
                    Accessibile a piedi? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile a piedi (specifica eventuali vestiari come scarpe anti
                    infortunistica, giubini o altro) </Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${footNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={footNote?.length === 0}
                    value={footNote}
                    onChange={(event) => setFootNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForBus}
                    onChange={() => setIsAccessibleForBus(!isAccessibleForBus)}
                >
                    Accessibile con autobus? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile con l'autobus (specifica eventuali fermate dell'autobus o
                    altro)</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${busNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={busNote?.length === 0}
                    value={busNote}
                    onChange={(event) => setBusNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForSkate}
                    onChange={() => setIsAccessibleForSkate(!isAccessibleForSkate)}
                >
                    Accessibile per monopattini? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile con skate (descrivi eventuali parchi skater o luogi
                    conformi)</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${skateNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={skateNote?.length === 0}
                    value={skateNote}
                    onChange={(event) => setSkateNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForMotorcycle}
                    onChange={() => setIsAccessibleForMotorcycle(!isAccessibleForMotorcycle)}
                >
                    Accessibile per motociclette? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile con motociclette (descrivi eventuali parcheggi e distributori
                    di benzina) </Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di caratteri 2000 (${motorcycleNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={motorcycleNote?.length === 0}
                    value={motorcycleNote}
                    onChange={(event) => setMotorcycleNote(event?.target?.value)}/>
            </Flex>
            <Flex flexDirection="column">
                <Checkbox
                    isChecked={isAccessibleForHourse}
                    onChange={() => setIsAccessibleForHourse(!isAccessibleForHourse)}
                >
                    Accessibile con cavalli? (Attiva se pensi sia accessibile)</Checkbox>
                <Text>Descrivi perchè è/non è accessibile con cavalli</Text>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${hourseNote?.length || "0"}/2000)`}</Text>
                <Textarea
                    isInvalid={hourseNote?.length === 0}
                    value={hourseNote}
                    onChange={(event) => setHourseNote(event?.target?.value)}/>
            </Flex>

            {/* AREA PER INSERIRE INDIRIZZI WEB  */}
            <div style={{display: "flex", alignItems: "center"}}>
                <h2 style={{marginRight: '10px'}}>Indirizzi web</h2>
                <DocsElement docs={docs.urls.docs}/>
            </div>
            <Flex flexDirection="column" gap="10px" border="1px solid black" p="10px" borderRadius="10px">
                <Flex flexDirection="row" gap="10px">
                    <Input value={url} onChange={(event) => setUrl(event?.target?.value)}/>
                    <Button
                        disabled={url?.length === 0 || urlDescription?.length === 0}
                        onClick={() => {
                            if (url?.length === 0 || urlDescription?.length === 0) return;
                            setInsertUrls(prevState =>
                                ([
                                    ...prevState,
                                    {
                                        link: url,
                                        description: urlDescription,
                                        key: shortid.generate()
                                    }
                                ])
                            )
                            setUrl("");
                            setUrlDescription("");
                        }}
                    >
                        AGGIUNGI
                    </Button>
                </Flex>
                <p>Descrizione (Descrivi il sito web inserito cosa contiene e come può aiutare l'utente)</p>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${urlDescription?.length || "0"}/2000)`}</Text>
                <Textarea value={urlDescription} onChange={(event) => setUrlDescription(event?.target?.value)}/>
                <Divider borderColor="blackAlpha.500"/>
                <Divider borderColor="blackAlpha.500"/>
                <p>Lista degli indirizzi web che verrano aggiunti al punto di interesse</p>
                {
                    insertUrls && insertUrls.map(element => {
                        return (
                            <Flex key={element.key} flexDirection="column" gap="10px"
                                  border="1px solid black" p="10px" borderRadius="10px">
                                <Flex flexDirection="row" gap="10px">
                                    <Input
                                        isInvalid={element?.link?.length === 0}
                                        onChange={(event) => {
                                            setInsertUrls(prevState => {
                                                return (insertUrls.map(e => {
                                                    if (e === element) return ({
                                                        ...e,
                                                        link: event?.target?.value
                                                    })
                                                    return e;
                                                }));
                                            })
                                        }}
                                        value={element?.link}/>
                                    <Button onClick={() => setInsertUrls(insertUrls.filter(e => e !== element))}>
                                        ELIMINA
                                    </Button>
                                </Flex>
                                <Text fontSize={"12px"}
                                      color={"brown"}>{`Limite massimo di 2000 caratteri (${element?.description?.length || "0"}/2000)`}</Text>
                                <Textarea
                                    isInvalid={element?.description?.length === 0}
                                    onChange={(event) => {
                                        setInsertUrls(prevState => {
                                            return (insertUrls.map(e => {
                                                if (e === element) return ({
                                                    ...e,
                                                    description: event?.target?.value
                                                })
                                                return e;
                                            }));
                                        })
                                    }}
                                    value={element?.description}/>
                            </Flex>
                        )
                    })
                }
            </Flex>

            {/* AREA PER INSERIRE TELEFONINI/CELLULARI */}
            <div style={{display: "flex", alignItems: "center"}}>
                <h2 style={{marginRight: '10px'}}>Cellulari/Telefoni:</h2>
                <DocsElement docs={docs.telephone.docs}/>
            </div>
            <Flex flexDirection="column" gap="10px" border="1px solid black" p="10px" borderRadius="10px">
                <Flex flexDirection="row" gap="10px">
                    <Input value={telephone} onChange={(event) => setTelephone(event?.target?.value)}/>
                    <Button
                        disabled={telephone?.length === 0 || telephoneDescription?.length === 0}
                        onClick={() => {
                            if (telephone?.length === 0 || telephoneDescription?.length === 0) return;
                            setInsertTelephones(prevState =>
                                ([
                                    ...prevState,
                                    {
                                        telephone,
                                        description: telephoneDescription,
                                        key: shortid.generate()
                                    }
                                ])
                            )
                            setTelephone("");
                            setTelephoneDescription("");
                        }}
                    >
                        AGGIUNGI
                    </Button>
                </Flex>
                <p>Descrizione (Descrivi il cellulare inserito specificando chi risponderà e qual è il suo scopo)</p>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${telephoneDescription?.length || "0"}/2000)`}</Text>
                <Textarea value={telephoneDescription}
                          onChange={(event) => setTelephoneDescription(event?.target?.value)}/>
                <Divider borderColor="blackAlpha.500"/>
                <Divider borderColor="blackAlpha.500"/>
                <p>Lista dei telefoni/cellulari che verrano aggiunti al punto di interesse</p>
                {
                    insertTelephones && insertTelephones?.map(element => {
                        return (
                            <Flex key={element.key} flexDirection="column" gap="10px"
                                  border="1px solid black" p="10px" borderRadius="10px">
                                <Flex flexDirection="row" gap="10px">
                                    <Input
                                        isInvalid={element?.telephone?.length === 0}
                                        onChange={(event) => {
                                            setInsertTelephones(prevState => {
                                                return (insertTelephones.map(e => {
                                                    if (e === element) return ({
                                                        ...e,
                                                        telephone: event?.target?.value
                                                    })
                                                    return e;
                                                }));
                                            })
                                        }} value={element?.telephone}/>
                                    <Button
                                        onClick={() => setInsertTelephones(insertTelephones.filter(e => e !== element))}>
                                        ELIMINA
                                    </Button>
                                </Flex>
                                <Text fontSize={"12px"}
                                      color={"brown"}>{`Limite massimo di 2000 caratteri (${element?.description?.length || "0"}/2000)`}</Text>
                                <Textarea
                                    isInvalid={element?.description?.length === 0}
                                    onChange={(event) => {
                                        setInsertTelephones(prevState => {
                                            return (insertTelephones.map(e => {
                                                if (e === element) return ({
                                                    ...e,
                                                    description: event?.target?.value
                                                })
                                                return e;
                                            }));
                                        })
                                    }} value={element?.description}/>
                            </Flex>
                        )
                    })
                }
            </Flex>

            {/* AREA PER INSERIRE EMAILS */}
            <div style={{display: "flex", alignItems: "center"}}>
                <h2 style={{marginRight: "10px"}}>Emails:</h2>
                <DocsElement docs={docs.emails.docs}/>
            </div>
            <Flex flexDirection="column" gap="10px" border="1px solid black" p="10px" borderRadius="10px">
                <Flex flexDirection="row" gap="10px">
                    <Input value={email} onChange={(event) => setEmail(event?.target?.value)}/>
                    <Button
                        disabled={email?.length === 0 || emailDescription?.length === 0}
                        onClick={() => {
                            if (email?.length === 0 || emailDescription?.length === 0) return;
                            setInsertEmails(prevState =>
                                ([
                                    ...prevState,
                                    {
                                        email,
                                        description: emailDescription,
                                        key: shortid.generate()
                                    }
                                ])
                            )
                            setEmail("");
                            setEmailDescription("");
                        }}
                    >
                        AGGIUNGI
                    </Button>
                </Flex>
                <p>Descrizione (Descrivi l'e-mail a chi è rivolta e come può servire all'utente. Ad esempio
                    prenotazioni, richieste specifice ect..)</p>
                <Text fontSize={"12px"}
                      color={"brown"}>{`Limite massimo di 2000 caratteri (${emailDescription?.length || "0"}/2000)`}</Text>
                <Textarea value={emailDescription} onChange={(event) => setEmailDescription(event?.target?.value)}/>
                <Divider borderColor="blackAlpha.500"/>
                <Divider borderColor="blackAlpha.500"/>
                <p>Lista delle email che verrano aggiunti al punto di interesse</p>
                {
                    insertEmails && insertEmails?.map(element => {
                        return (
                            <Flex key={element.key} flexDirection="column" gap="10px"
                                  border="1px solid black" p="10px" borderRadius="10px">
                                <Flex flexDirection="row" gap="10px">
                                    <Input
                                        isInvalid={element?.email?.length === 0}
                                        onChange={(event) => {
                                            setInsertEmails(prevState => {
                                                return (insertEmails.map(e => {
                                                    if (e === element) return ({
                                                        ...e,
                                                        email: event?.target?.value
                                                    })
                                                    return e;
                                                }));
                                            })
                                        }}
                                        value={element?.email}/>
                                    <Button onClick={() => setInsertEmails(insertEmails.filter(e => e !== element))}>
                                        ELIMINA
                                    </Button>
                                </Flex>
                                <Text fontSize={"12px"}
                                      color={"brown"}>{`Limite massimo di 2000 caratteri (${element?.description?.length || "0"}/2000)`}</Text>
                                <Textarea
                                    isInvalid={element?.description?.length === 0}
                                    onChange={(event) => {
                                        //console.log("email cambiamento")
                                        setInsertEmails(prevState => {
                                            return (insertEmails.map(e => {
                                                if (e === element) return ({
                                                    ...e,
                                                    description: event?.target?.value
                                                })
                                                return e;
                                            }));
                                        })
                                    }}
                                    value={element?.description}/>
                            </Flex>
                        )
                    })
                }
            </Flex>

            {/* INSERIMENTO DELLE IMMAGINI  */}
            <Flex flexDirection="column"
                  border={`${insertFiles?.length > 0 ? "1" : "2"}px solid ${insertFiles?.length > 0 ? "black" : "red"}`}
                  padding="10px" gap="10px" borderRadius="10px">
                <DocsElement docs={docs.img.docs}/>
                <p>Caricare immagini: Singola foto minore di 2MB. Massimo di foto 10MB</p>
                <p style={{fontWeight: "bold"}}>Perfavore caricare almeno 2 foto</p>
                <Flex border="1px solid black" borderRadius="20px" flexDirection="column-reverse" padding="10px"
                      gap="10px">
                    <Flex flex={3} justifyContent="space-between" alignItems="center">
                        <Text>{image?.filename}</Text>
                        <Text>{image?.type}</Text>
                    </Flex>
                    <Flex flex={1} justifyContent="center" alignItems="center">
                        <Button
                            disabled={image == null || imageDescription?.length === 0}
                            onClick={() => {
                                if (image == null || imageDescription?.length === 0) {
                                    setPopupData({
                                        status: false,
                                        title: 'Aggiunta fallita',
                                        message: "Manca qualche informazione"
                                    })
                                    setModalOpen(true)
                                    return;
                                }
                                setInsertFiles(prevState => ([...prevState, {
                                    ...image,
                                    key: shortid.generate(),
                                    description: imageDescription
                                }]));
                                setImage(null);
                                setImageDescription("");
                            }}
                            variant="solid" size="md"
                        >
                            AGGIUNGI
                        </Button>
                    </Flex>
                    <Flex justifyContent="center" alignItems="center">
                        <Image
                            alt="Anteprima non disponibile"
                            height="80%"
                            src={image?.preview}/>
                    </Flex>
                    <Flex flexDirection="column" gap="10px" padding="10px">
                        <Text>Descrizione</Text>
                        <Text fontSize={"12px"}
                              color={"brown"}>{`Limite massimo di 2000 caratteri (${imageDescription?.length || "0"}/2000)`}</Text>
                        <Textarea
                            value={imageDescription}
                            onChange={(event) => setImageDescription(event?.target?.value)}/>
                    </Flex>
                    <input
                        accept="image/png, image/jpeg"
                        type="file"
                        onChange={onFileChange}
                    />
                    <Button
                        onClick={() => {
                            setImage(null)
                            setImageDescription("")
                        }}
                    >
                        ANNULLA
                    </Button>
                </Flex>
                <Divider/>
                <Divider/>
                <p>Immagini che verrano aggiunte al punto di interesse</p>
                {
                    insertFiles && insertFiles.map(element => {
                        return (
                            <Flex key={element.key} border="1px solid black" borderRadius="20px"
                                  flexDirection="column-reverse"
                                  padding="10px" gap="10px">
                                <Flex flex={3} justifyContent="space-between" alignItems="center">
                                    <Text>{element?.filename}</Text>
                                    <Text>{element?.type}</Text>
                                </Flex>
                                <Flex flex={1} justifyContent="center" alignItems="center">
                                    <Button
                                        onClick={() => setInsertFiles(insertFiles.filter(e => e !== element))}
                                        variant="solid" size="md"
                                    >
                                        Elimina
                                    </Button>
                                </Flex>
                                <Flex justifyContent="center" alignItems="center">
                                    <img
                                        alt="Anteprima non disponibile"
                                        height="80%"
                                        //src={element?.preview}
                                        src={element.imageBase64}
                                    />
                                </Flex>
                                <Flex flexDirection="column" gap="10px" padding="10px">
                                    <Text>Descrizione</Text>
                                    <Text fontSize={"12px"}
                                          color={"brown"}>{`Limite massimo di 2000 caratteri (${element?.description?.length || "0"}/2000)`}</Text>
                                    <Textarea
                                        isInvalid={element?.description?.length === 0}
                                        value={element?.description}
                                        onChange={(event) => {
                                            setInsertFiles(prevState => {
                                                return (insertFiles.map(e => {
                                                    if (e === element) return ({
                                                        ...e,
                                                        description: event?.target?.value
                                                    })
                                                    return e;
                                                }));
                                            })
                                        }}/>
                                </Flex>
                            </Flex>
                        )
                    })
                }
            </Flex>
            <Flex flexDirection={"column"} gap={"20px"}>
                <Checkbox
                    isChecked={isCompleted}
                    onChange={(event) => {
                        setIsCompleted(event?.target?.checked)
                    }}
                >
                    Spunta se la scheda è terminata
                </Checkbox>
                <DocsElement docs={docs.missed.docs}/>
                <Text>Descrivi eventualmente cosa ti manca per terminare questo POI</Text>
                <Textarea
                    value={missingNote}
                    onChange={(event) => setMissingNote(event?.target?.value)}/>
            </Flex>

            {
                (!props?.data || (props?.data && _id)) && <Button
                    onClick={() => savePoi()}
                >
                    SALVA
                </Button>
            }
            {
                (props?.data && !_id) &&
                <Button
                    onClick={updatePoi}
                >
                    AGGIORNA
                </Button>
            }
            {
                (!props?.data || (props?.data && _id)) && <Button
                    onClick={addPoi}
                    disabled={!isAddEnabled}
                >
                    AGGIUNGI
                </Button>
            }
            {
                //Esiste solo in caso di Salva e Aggiungi (non in update)
                ((!props?.data || (props?.data && _id)) && (!props?.data || (props?.data && _id))) &&
                <AgreeAndContinue
                    onChangeAgree={(value) => {
                        setIsAgree(value)
                    }}/>
            }

            <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
            <Loading isLoading={isAddPoiLoading || isSavePoiDownloading || isUpdatePoiDownloading}/>
            <RequestingPopup
                isOpen={isDialogConfirmOpen}
                onDeny={() => {
                    setIsDialogConfirmOpen(false);
                }}
                onAccept={() => {
                    leave[`${leave_key}`]?.func();
                    setIsDialogConfirmOpen(false);
                }}
            />
        </Flex>
    );
};

export default PointOfInterestForm;
